module.exports = __webpack_public_path__ + "static/media/realestate_img.e81539f3.jpg";